module.exports = __webpack_public_path__ + "img/aac.52f3c482.svg";